import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import PersonPinIcon from '@mui/icons-material/PersonPin';
import {
  Box,
  Breadcrumbs,
  Button,
  Link as MLink,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import PageHeader from '../components/PageHeader';
import AccountContainer from '../container/AccountContainer';
import AccountOtherInformationContainer from '../container/AccountOtherInformationContainer';
import { useAccount } from '../hooks/api/account';
import { Link } from 'react-router-dom';
import { HomeTwoTone } from '@mui/icons-material';

export default function AccountInfosPage() {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));
  const { data: user } = useAccount();
  const [activeSection, setActiveSection] = useState(0);

  const handleSectionChange = (newValue: number) => {
    setActiveSection(newValue);
  };

  const StyledButton = styled(Button)(({ theme }) => ({
    textTransform: 'none',
    margin: theme.spacing(1),
    borderRadius: '4px',
    display: 'flex',
    alignItems: 'center',
    color: '#000000',
    minWidth: '172px',
    fontWeight: theme.typography.fontWeightMedium,
    boxShadow: '0 2px 5px rgba(0, 0, 0, 0.15)',
    '&.Mui-selected': {
      backgroundColor: '#DEF1F0',
      color: '#000000',
    },
  }));

  return (
    <Box>
      <PageHeader title={t('accountInfosPage.title')} />
      <Breadcrumbs sx={{ mb: 1 }}>
        <MLink
          component={Link}
          to="/"
          style={{ display: 'flex', alignItems: 'center' }}
        >
          <HomeTwoTone />
        </MLink>
        <MLink component={Link} to="/account">
          {t('nav.account')}
        </MLink>
        <Typography>{t('accountInfosPage.title')}</Typography>
      </Breadcrumbs>
      <Box sx={{ border: '2px solid #eee', borderRadius: '10px', p: '24px' }}>
        <Box
          sx={{
            display: 'flex',
            overflowX: 'auto',
            justifyContent: 'start',
            marginBottom: 2,
          }}
        >
          <StyledButton
            variant={activeSection === 0 ? 'contained' : 'outlined'}
            startIcon={<AccountCircleIcon />}
            className={activeSection === 0 ? 'Mui-selected' : ''}
            onClick={() => handleSectionChange(0)}
          >
            {t('accountInfosPage.membershipInformation')}
          </StyledButton>
          <StyledButton
            variant={activeSection === 1 ? 'contained' : 'outlined'}
            startIcon={<PersonPinIcon />}
            className={activeSection === 1 ? 'Mui-selected' : ''}
            onClick={() => handleSectionChange(1)}
          >
            {t('accountInfosPage.otherInformation')}
          </StyledButton>
        </Box>
        <Box>
          {activeSection === 0 && (
            <Box>
              <AccountContainer user={user} />
            </Box>
          )}
          {activeSection === 1 && (
            <Box>
              <AccountOtherInformationContainer />
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
}
